import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";
import { SeguridadGateway } from "../../domain/model/seguridad/gateway/seguridad-gateway";
import { Usuario } from "../../shared/models/usuario.model";

@Injectable({
  providedIn: 'root'
})
export class SeguridadService extends SeguridadGateway {
   
    private readonly url: string;
    private readonly port: string;

    constructor(private readonly http: HttpClient) {
        super();
        this.url = `${environment.apiBaseUrl}`;
        this.port = `${environment.portBaseUrl}`;
    }
  login(urlInicio: string): Observable<any> {
    const url = `${this.url}${this.port}/api_ingreso/seus/login/form`;
    return this.http.post(url, urlInicio);
  }

  checkLogin(): Observable<boolean> {
    const url = `${this.url}${this.port}/api_ingreso/seus/user/check`;
    return this.http.get<boolean>(url);
  }

  datosUsuarioLogueado(): Observable<Usuario> {
    const url = `${this.url}${this.port}/api_ingreso/seus/user/current`;
    return this.http.get<Usuario>(url);
  }

  cerrarSesion() {
    const url = `${this.url}${this.port}/api_ingreso/seus/logout`;
    return this.http.get(url, {responseType: 'text'});
  }

}
